import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, Switch } from 'react-router-dom';

import Reports from "../containers/Reports";
import AuthorizedUser from "../utils/AuthorizedUser";
import AuthorizedUserContext from "../utils/AuthorizedUserContext";

function ReportsRouter(props) {
	const authenticatedUser = useContext(AuthorizedUserContext);
	let {updateHeader, resetHeader, showSnackbar, setBannerClassName,
			setFullScreenClassName, hasNudgeBanner, csm} = props,
		routes = ReportsRouter.getRoutes();

	return (
		<Switch>
			<Redirect
				exact
				from={routes[0]}
				to={routes[1]} />
			{AuthorizedUser.hasReports(authenticatedUser) ?
				<Route
					path={routes[1]}
					render={renderProps =>
						<Reports
							{...renderProps}
							csm={csm}
							updateHeader={updateHeader}
							resetHeader={resetHeader}
							showSnackbar={showSnackbar}
							hasNudgeBanner={hasNudgeBanner}
							setBannerClassName={setBannerClassName}
							setFullScreenClassName={setFullScreenClassName} />
					} />
				:
				<Redirect
					from={routes[1]}
					to="/no-access" />
			}

			{AuthorizedUser.hasSocialMediaReports(authenticatedUser) ?
				<Route
					path={routes[2]}
					render={renderProps =>
						<Reports
							{...renderProps}
							csm={csm}
							updateHeader={updateHeader}
							resetHeader={resetHeader}
							showSnackbar={showSnackbar}
							hasNudgeBanner={hasNudgeBanner}
							setBannerClassName={setBannerClassName}
							setFullScreenClassName={setFullScreenClassName} />
					} />
				:
				<Redirect
					from={routes[2]}
					to="/no-access" />
			}

			{AuthorizedUser.hasGSuiteReports(authenticatedUser) ?
				<Route
					path={routes[3]}
					render={renderProps =>
						<Reports
							{...renderProps}
							csm={csm}
							updateHeader={updateHeader}
							resetHeader={resetHeader}
							showSnackbar={showSnackbar}
							hasNudgeBanner={hasNudgeBanner}
							setBannerClassName={setBannerClassName}
							setFullScreenClassName={setFullScreenClassName} />
					} />
				:
				<Redirect
					from={routes[3]}
					to="/no-access" />
			}

			{AuthorizedUser.hasExchange(authenticatedUser) ?
				<Route
					path={routes[4]}
					render={renderProps =>
						<Reports
							{...renderProps}
							csm={csm}
							updateHeader={updateHeader}
							resetHeader={resetHeader}
							showSnackbar={showSnackbar}
							hasNudgeBanner={hasNudgeBanner}
							setBannerClassName={setBannerClassName}
							setFullScreenClassName={setFullScreenClassName} />
					} />
				:
				<Redirect
					from={routes[4]}
					to="/no-access" />
			}

			{AuthorizedUser.hasShareit(authenticatedUser) ?
				<Route
					path={routes[5]}
					render={renderProps =>
						<Reports
							{...renderProps}
							csm={csm}
							updateHeader={updateHeader}
							resetHeader={resetHeader}
							showSnackbar={showSnackbar}
							hasNudgeBanner={hasNudgeBanner}
							setBannerClassName={setBannerClassName}
							setFullScreenClassName={setFullScreenClassName} />
					} />
				:
				<Redirect
					from={routes[5]}
					to="/no-access" />
			}

			{AuthorizedUser.isAdmin(authenticatedUser) ?
				<Route
					path={routes[6]}
					render={renderProps =>
						<Reports
							{...renderProps}
							csm={csm}
							updateHeader={updateHeader}
							resetHeader={resetHeader}
							showSnackbar={showSnackbar}
							hasNudgeBanner={hasNudgeBanner}
							setBannerClassName={setBannerClassName}
							setFullScreenClassName={setFullScreenClassName} />
					} />
				:
				<Redirect
					from={routes[6]}
					to="/no-access" />
			}

			{AuthorizedUser.isAdmin(authenticatedUser) ?
				<Route
					path={routes[7]}
					render={renderProps =>
						<Reports
							{...renderProps}
							csm={csm}
							updateHeader={updateHeader}
							resetHeader={resetHeader}
							showSnackbar={showSnackbar}
							hasNudgeBanner={hasNudgeBanner}
							setBannerClassName={setBannerClassName}
							setFullScreenClassName={setFullScreenClassName} />
					} />
				:
				<Redirect
					from={routes[7]}
					to="/no-access" />
			}
			
			{AuthorizedUser.hasWebSearchReports(authenticatedUser) ?
				<Route
					path={routes[8]}
					render={renderProps =>
						<Reports
							{...renderProps}
							csm={csm}
							updateHeader={updateHeader}
							resetHeader={resetHeader}
							showSnackbar={showSnackbar}
							hasNudgeBanner={hasNudgeBanner}
							setBannerClassName={setBannerClassName}
							setFullScreenClassName={setFullScreenClassName} />
					} />
				:
				<Redirect
					from={routes[8]}
					to="/no-access" />
			}
		</Switch>
	);
}

ReportsRouter.getRoutes = () => {
	const routes = [
		"/reports",
		"/reports/overview",
		"/reports/social-media",
		"/reports/gsuite",
		"/reports/outlook",
		"/reports/shareit",
		"/reports/audit-trail",
		"/reports/alert-summary",
		"/reports/web-search"
	];
	return routes;
};

ReportsRouter.propTypes = {
	updateHeader: PropTypes.func,
	resetHeader: PropTypes.func,
	showSnackbar: PropTypes.func,
	setBannerClassName: PropTypes.func,
	hasNudgeBanner: PropTypes.bool,
	csm: PropTypes.object.isRequired,
	setFullScreenClassName: PropTypes.func
};

export default ReportsRouter;